import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInServicePendingChecklist } from "models";

export const useReorderServicePendingChecklistMutation = () =>
  useTypedMutation<CheckInServicePendingChecklist[], void>({
    mutationFn: async checkin_service_pending_checklists =>
      (await ApiInstance.post("/service_pending_checklists/reorder", { checkin_service_pending_checklists }, ENV.dealerBaseURL)).data,
    onSuccess: reorderedChecklists => {
      const servicePendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.servicePendingChecklists);
      if (!servicePendingChecklists?.length || !reorderedChecklists.length) return;

      const otherChecklists = servicePendingChecklists.filter(p => p.checkin_service_id !== reorderedChecklists[0].checkin_service_id);
      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.servicePendingChecklists, [...otherChecklists, ...reorderedChecklists]);
    }
  });
